"use client";

import { createContext } from "react";
import type {
  AktiverTestlauf,
  AufgeloesteRegeln,
  AufgeloesteVorgabe,
} from "@/dev-testbed/testlauf/typen.ts";

export type TestScopeKontext = {
  aktiv: boolean;
  beobachtungsmodus: boolean;
  regeln: AufgeloesteRegeln | null;
  routeErlaubt(pfad: string): boolean;
  aktionErlaubt(id: string): boolean;
  vorgabeFuer(feld: string): AufgeloesteVorgabe | null;
  meldeEreignis(art: string, wert: string): void;
  /** Letzter serverseitiger Abschluss (A7) — Statusband liest mit. */
  letzterAbschluss: AbschlussMeldung | null;
};

export type AbschlussMeldung = {
  abschluss: "erfolgreich" | "fehlgeschlagen";
  fehlergrund?: string | null;
  dauerMs?: number | null;
  costUsd?: number | null;
};

export const inaktiverTestScope: TestScopeKontext = {
  aktiv: false,
  beobachtungsmodus: false,
  regeln: null,
  routeErlaubt: () => true,
  aktionErlaubt: () => true,
  vorgabeFuer: () => null,
  meldeEreignis: () => {},
  letzterAbschluss: null,
};

export const TestScopeContext = createContext<TestScopeKontext | null>(null);

export type AktiverLaufState = AktiverTestlauf | null;
